import { SizableText, XStack, XStackProps } from 'tamagui'
import { Globe2, Lock } from '@tamagui/lucide-icons'

type VisibilityBadgeProps = {
  visibility: 'public' | 'private' | string
}

const iconMap = {
  public: Globe2,
  private: Lock,
}

export const VisibilityBadge = ({ visibility, ...props }: VisibilityBadgeProps & XStackProps) => {
  const Icon = iconMap[visibility] || Lock
  return (
    <XStack flex={0} br="$2" ai="center" bg="$overlay6" gap="$1.5" py="$1" px="$2" {...props}>
      <Icon size={12} />
      <SizableText size="$1" fow="500">
        {visibility === 'public' ? 'Public' : 'Private'}
      </SizableText>
    </XStack>
  )
}
